export const baseUrl = () => location.origin
